import * as R from 'ramda'
import React, { Fragment } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

import useAxios from 'hooks/useAxios'
import { BillingContainer } from 'organisms/Billing/container'
import { Loader } from 'shared/components/Loader'
import { ContentContainer } from 'components/ContentContainer'
import PageHeaderContainer from 'shared/components/PageHeader/container'
import { toastr } from 'libs/toast'

import { Elements } from '@stripe/react-stripe-js'
import { getStripePromise } from 'libs/stripe/get-stripe-promise'
import { getPublishableKey } from 'libs/billing/stripe-account'

function Billing() {
  const history = useHistory()

  const { data: user } = useAxios({
    /* use /users/me/ (not v2/) because this page need to sync invoice */
    url: 'account/users/me/',
  })
  const { data: billing } = useAxios({
    url: 'billing/',
  })
  const { data: plans } = useAxios({
    url: 'billing/plans/',
  })

  const location = useLocation()
  const errorMessage = R.path(['state', 'error'], location)

  if (errorMessage) {
    toastr.warning(errorMessage)
    history.replace({ state: {} })
  }

  if (!user || !billing || !plans) {
    return (
      <Fragment>
        <PageHeaderContainer title="Billing" />
        <ContentContainer>
          <Loader withContainer />
        </ContentContainer>
      </Fragment>
    )
  }

  const publishableKey = getPublishableKey(billing)

  return (
    <Fragment>
      <PageHeaderContainer title="Billing" />
      <ContentContainer>
        <Elements
          key={publishableKey}
          stripe={getStripePromise(publishableKey)}
          // @ts-ignore
          options={customStylesStripeElement}
        >
          <div className="ui segment admin-section bg-white">
            <BillingContainer user={user} billing={billing} plans={plans} />
          </div>
        </Elements>
      </ContentContainer>
    </Fragment>
  )
}

export default Billing

export const customStylesStripeElement = {
  // @ts-ignore
  appearance: {
    theme: 'stripe',
    variables: {
      fontFamily: 'Lato, sans-serif',
      fontSizeBase: '16px',
      borderRadius: '4px',
      spacingUnit: '3px',
      colorText: '#373f46',
      gridRowSpacing: '15px',
    },
    rules: {
      '.Label': {
        fontWeight: '700',
        fontSize: '1rem',
        fontFamily: 'Lato, sans-serif',
        margin: '0 0 .25rem 0',
      },
      '.Input:focus': {
        colorText: 'rgba(0, 0, 0, .95)',
        borderColor: '#85b7d9',
        borderRadius: '.25rem',
        background: '#fff',
        boxShadow: '0 0 0 0 rgba(34, 36, 38, .35) inset',
      },
      '.Input--invalid': {
        background: '#fff6f6',
        borderColor: '#e0b4b4',
        colorText: '#9f3a38',
        boxShadow: 'none',
      },
      '.Input': {
        border: '1px solid #58667e1f',
        borderRadius: '.25rem',
        boxShadow: '0 0 0 0 transparent inset',
        padding: '.58035714em .875em',
        lineHeight: '1.21428571em',
        fontSize: '1em',
      },
      '.Input::placeholder': {
        color: '#b4b4b4',
      },
    },
  },
  fonts: [
    {
      family: 'Lato',
      src: 'url(https://fonts.gstatic.com/s/lato/v24/S6u9w4BMUTPHh6UVSwiPGQ3q5d0.woff2)',
      weight: '700',
    },
    {
      family: 'Lato',
      src: 'url(https://fonts.gstatic.com/s/lato/v24/S6uyw4BMUTPHjx4wXiWtFCc.woff2)',
      weight: '400',
    },
  ],
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/pages/Admin/Billing/index.js